// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getDefaultKeyValueState} from './key-value-pair';
import t from 'tcomb';

const UseAmount = t.struct({
    amount: t.maybe(t.Number),
    unit: KeyValuePair
}, {
    name: 'UseAmount',
    strict: true
});

export const getDefaultState = () => new UseAmount({
    amount: null,
    unit: getDefaultKeyValueState()
});

export default UseAmount;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/use-amount.js